<div class="container mb-100">

  <div class="header-title-container">
    <adp-label labelKey="Account_Subscription_Heading"></adp-label>

    <span *ngIf="!contract.subscriberStatusCode || contract.subscriberStatusCode === 'A'" class="status-button-active">
      <adp-label labelKey="Account_Subscription_Status_Active"></adp-label>
    </span>
    <span *ngIf="contract.subscriberStatusCode === 'S'" class="status-button-suspended">
      <adp-label labelKey="Account_Subscription_Status_Suspended"></adp-label>
    </span>
    <span *ngIf="contract.subscriberStatusCode === 'C'" class="status-button-cancelled">
      <adp-label labelKey="Account_Subscription_Status_Cancelled"></adp-label>
    </span>


    <div class="manage-link desktop-view">
      <a [href]="manageUrl" target="_blank">
        <adp-label labelKey="Account_Subscription_Manage_Link_Text"></adp-label>
        <mat-icon [svgIcon]="'new-page'" class="open-icon"></mat-icon>
      </a>
    </div>

    <div class="mt-10 manage-link-mobile mobile-view">
      <a [href]="manageUrl" target="_blank">
        <div>
          <adp-label labelKey="Account_Subscription_Manage_Link_Text" style="float:left;margin-top:5px;"></adp-label>
          <mat-icon [svgIcon]="'new-page'" class="open-icon" style="float:right;"></mat-icon>
        </div>
      </a>
    </div>

  </div>
  <div class="mt-10">
    <div class="mt-20 pb-4 header-desc">
      <adp-label labelKey="Account_Subscription_Description"></adp-label>
    </div>
  </div>

  <mat-divider class="divider"></mat-divider>

  <div class="row">
    <div class="col col-xs-8 col-sm-10 mt-20 subscription-desc subscription-cost-heading">
      <adp-label labelKey="Account_Subscription_Cost_Subheading"></adp-label>
    </div>
    <div class="col col-xs-4 col-sm-2 mt-20 subscription-desc subscription-cost-heading" style="text-align:right;">
      <span>{{contract?.grossPolicyPrice | currency}} </span><br>
      <span class="subscription-cost-sub-text"><adp-label labelKey="Account_Subscription_Cost_SubText"></adp-label></span>
    </div>
    <div class="mt-20 subscription-desc">
      <adp-label labelKey="Account_Subscription_Cost_Description"></adp-label>
    </div>
  </div>

  <div class="row">
    <div class="mt-20 mb-10 subscription-desc subscription-subheading">
      <adp-label labelKey="Account_Subscription_Products_Subheading"></adp-label>
    </div>
  </div>

  <div class="row desktop-view text-centered">
    <div class="col-2">
      <mat-icon [svgIcon]="'refrigerator-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Refrigerators"></adp-label>
      </div>
    </div>
    <div class="col-2">
      <mat-icon [svgIcon]="'washer-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Washers"></adp-label>
      </div>
    </div>
    <div class="col-2">
      <mat-icon [svgIcon]="'microwave-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Microwaves"></adp-label>
      </div>
    </div> 
    <div class="col-2">
      <mat-icon [svgIcon]="'ranges-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Ranges"></adp-label>
      </div>
    </div>
    <div class="col-2">
      <mat-icon [svgIcon]="'dishwasher-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Dishwashers"></adp-label>
      </div>
    </div>
    <div class="col-2">
      <mat-icon [svgIcon]="'wall-oven-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Cooktops"></adp-label>
      </div>
    </div>
  </div>

  <div class="row mobile-view">
    <div class="col-6">
      <mat-icon [svgIcon]="'refrigerator-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Refrigerators"></adp-label>
      </div>
    </div>
    <div class="col-6">
      <mat-icon [svgIcon]="'washer-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Washers"></adp-label>
      </div>
    </div>
    <div class="col-6">
      <mat-icon [svgIcon]="'microwave-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Microwaves"></adp-label>
      </div>
    </div>
    <div class="col-6">
      <mat-icon [svgIcon]="'ranges-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Ranges"></adp-label>
      </div>
    </div>
    <div class="col-6">
      <mat-icon [svgIcon]="'dishwasher-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Dishwashers"></adp-label>
      </div>
    </div>
    <div class="col-6">
      <mat-icon [svgIcon]="'wall-oven-2tone'" class="product-icon"></mat-icon>
      <div class="mt-10 subscription-desc subscription-icon-subheading">
        <adp-label labelKey="Account_Subscription_Products_Cooktops"></adp-label>
      </div>
    </div>
  </div>
</div>
